import { Constant } from "../helper/constant";
import http, { navigatorAPI } from "./http";
import { getStorageData } from "./storage.service";

export const getIndustryList = () => {
  return http.get(Constant.API.GET_INDUSTRIES);
};

export const getAIMaturityEvaluationAPI = () => {
  const org = getStorageData(Constant.STORAGE_KEYS.USER_INFO);
  return navigatorAPI.get(Constant.API.GET_AI_MATURITY_EVALUATION, { params: { company: org.userInfo.org_name } });
}

export const getUnsignedRevenue = (payload) => {
  return http.post(Constant.API.CALCULATE_UNSIGNED_REVENUE, payload);
};

export const getGapAnalysisAPI = (data) => {
  return navigatorAPI.post(Constant.API.GET_AI_GAP_ANALYSIS, data);
}


export const getStrategicImpactAPI = (data) => {
  return navigatorAPI.post(Constant.API.GET_AI_STRATEGIC_IMPACT, data);
}

export const getExecutionCostAPI = () => {
  return navigatorAPI.get(Constant.API.GET_AI_EXECUTION_COST);
}

export const getFAQsAPI = () => {
  return navigatorAPI.get(Constant.API.GET_FAQS);
}

export const getTestimonialsAPI = () => {
  return navigatorAPI.get(Constant.API.TESTIMONIALS)
}

export const getAIUsecaseDocumentAPI = (email) => {
  const org = getStorageData(Constant.STORAGE_KEYS.USER_INFO);
  return navigatorAPI.get(Constant.API.AI_USERCASE_DOCUMENT, { params: { company: org.userInfo.org_name, email } });
}


export const createAIUsecaseDocumentAPI = payload => {
  return navigatorAPI.post(Constant.API.AI_USERCASE_DOCUMENT, payload);
}